import { IdentificationIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { Button } from '../../../components/ui/button';
import { DONATION_TONE } from '../../../constants/donation.const';

/** Asks a donor with tax-deductible donations and no IC number on file to add one. */
export function IcNumberBanner({ onAdd }: { onAdd: () => void }) {
  return (
    <section
      aria-label="Add your IC number"
      className={clsx(
        'flex gap-3 rounded-2xl border p-4',
        DONATION_TONE.pending
      )}
    >
      <IdentificationIcon
        className={clsx('h-6 w-6 shrink-0', DONATION_TONE.pendingText)}
        aria-hidden="true"
      />
      <div>
        <p className="text-sm font-semibold text-gray-900">
          Add your IC number to get tax-deductible receipts
        </p>
        <p className="mt-1 text-xs text-gray-700">
          LHDN requires it on every tax receipt. You only need to add it once.
        </p>
        <Button
          type="button"
          onClick={onAdd}
          className="mt-3 rounded-full bg-gray-900 px-4 text-white hover:bg-gray-800"
        >
          Add IC number
        </Button>
      </div>
    </section>
  );
}
